import React, { ReactNode, useCallback } from 'react';
import styled from 'styled-components';

import { IluckydrawItem } from '@typings/store/luckydraw.interface';
import { IslideItem } from '@typings/setting/slideItem';

const SlideItem = styled.div`
  min-width: 100%;
  height: 100%;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 1.5;

  cursor: var(--hoverCursorURL), pointer;

  .imgSec {
    width: 100%;
    height: fit-content;
    object-fit: cover;
  }

  &.active {
    opacity: 1;
    transition: 1s ease;
    transform: translateY(0);
  }
`;

const Img = styled.div`
  position: absolute;
  inset: 0;
  background: center / cover no-repeat;
`;

type Props = {
  data: IslideItem | IluckydrawItem;
  showButton: boolean;
  handleClick?: (any) => void;
  handleBtnClick?: () => void;
  current?: number;
  isActive: boolean;
  customContents?: ((data: any) => ReactNode) | ReactNode;
};
function SliderContents({
  data,
  isActive,
  handleClick,
  customContents,
}: Props) {
  const openPage = useCallback(
    (link: string, openInNewTab: boolean = true) => {
      if (openInNewTab) {
        window.open(link, '_blank');
      } else {
        window.location.href = link;
      }
    },
    [],
  );

  return (
    <SlideItem
      className={isActive ? 'active' : ''}
      onClick={() => {
        if (handleClick) handleClick(data);
        if (data.linkto) {
          const shouldOpenInNewTab =
            (data as IslideItem).openInNewTab ?? true;
          openPage(data.linkto, shouldOpenInNewTab);
        }
      }}
    >
      <Img style={{ backgroundImage: `url('${data.imgURL}')` }} />
      {typeof customContents === 'function'
        ? customContents(data)
        : customContents}
    </SlideItem>
  );
}

export default SliderContents;
